import { toast } from "react-toastify";
import { apiURL } from "../../config";

export async function getUnitsList(axiosPrivate) {
	return axiosPrivate
		.get(`${apiURL}/unit/list.json`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function getUnit(axiosPrivate, id) {
	return axiosPrivate
		.get(`${apiURL}/unit/${id}.json`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function addUnit(axiosPrivate, navigate, data) {
	return axiosPrivate
		.post(`${apiURL}/organization-unit.json`, data, {
			headers: { "Content-Type": "application/json" },
		})
		.then((res) => {
			if (res.status < 300 && res.status > 199) {
				toast.success("New unit has been added");
				navigate(`/units/${res.data.id}`, { replace: true });
			} else {
				toast.error("Adding units - error, try again");
			}
			return res;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function editUnit(axiosPrivate, id, data, cb = false) {
	return axiosPrivate
		.patch(`${apiURL}/organization-unit/${id}.json`, data, {
			headers: { "Content-Type": "application/json" },
		})
		.then((res) => {
			if (res.status < 300 && res.status > 199) {
				toast.success("Unit updated");
				if (cb) cb();
			} else {
				toast.error("Not updated, try again");
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function deleteUnit(axiosPrivate, id) {
	return axiosPrivate
		.delete(`${apiURL}/organization-unit/${id}.json`)
		.then((res) => {
			if (res.status >= 200 && res.status < 300) {
				toast.success("Unit deleted");
				return true;
			} else {
				toast.error("Failed to delete unit");
				return false;
			}
		})
		.catch((err) => {
			toast.error("Error deleting unit");
			return false;
		});
}